<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="6">
                        <el-col :span="24">
                            <el-form-item label="老师">
                                <el-select v-model="teacher_id"
                                           remote
                                           clearable
                                           filterable
                                           :remote-method="handleChooseTeacher"
                                           @change="handleCheck()"
                                           placeholder="请选择学生">
                                    <el-option
                                            v-for="item in $parentInfo.Dialog_SignCheck.choose_teachers"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-0">
            已签到学生数：{{$parentInfo.Dialog_SignCheck.finished_student}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_SignCheck",
        data() {
            return {
                teacher_id:'',
            }
        },
        mounted() {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleCheck()
            this.handleChooseTeacher('')
        },
        methods: {
            handleCheck(){
                this.$wApi.send(this.$parentInfo.path, 'sign_check', {
                    'teacher_id': this.teacher_id,
                    'date': this.$parentInfo.filter.date,
                    'section_id': this.$parentInfo.filter.section_id,
                });
            },
            handleChooseTeacher(query){
                if(!query){
                    query=''
                }
                this.$wApi.send(this.$parentInfo.path, 'choose_teacher', {
                    'section_id': this.$parentInfo.filter.section_id,
                    'date': this.$parentInfo.filter.date,
                    'name':query,
                });
            },
        }
    }
</script>

<style scoped>

</style>